import React, { useState } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { Typography } from '@scale/scaleui';
import TaskerScreeningBenchmarkCreationTool from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningBenchmarkCreationTool';
import TaskerScreeningBenchmarkReviewTool from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningBenchmarkReviewTool';
import TaskerScreeningBenchmarkCsvUploadTool from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningBenchmarkCsvUploadTool';

interface TaskerScreeningBenchmarksProps {
  user: IUserJson;
}

const TaskerScreeningBenchmarks: React.FC<TaskerScreeningBenchmarksProps> = ({ user }) => {
  const [needsFetch, setNeedsFetch] = useState(true);

  return (
    <div className="scaleui scale-theme scale-tailwind p-4">
      <div className="mb-8">
        <Typography.H4>Create Benchmarks</Typography.H4>
        <p>Use this tool to create auditor benchmarks, served in auditor review tables.</p>
        <div className="flex gap-2">
          <TaskerScreeningBenchmarkCreationTool user={user} setNeedsFetch={setNeedsFetch} />
          <TaskerScreeningBenchmarkCsvUploadTool user={user} setNeedsFetch={setNeedsFetch} />
        </div>
      </div>
      <div className="mb-8">
        <Typography.H4>Review Benchmarks</Typography.H4>
        <p className="mb-4">
          Use this tool to review auditor benchmarks. Here, you can view stats on existing
          benchmarks, and enable / disable them. Make sure to assign benchmarks to the relevant
          permission roles such that your auditors see them in their review tables.
        </p>
        <TaskerScreeningBenchmarkReviewTool
          user={user}
          needsFetch={needsFetch}
          setNeedsFetch={setNeedsFetch}
        />
      </div>
    </div>
  );
};

export default TaskerScreeningBenchmarks;
